import React, { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { Notification as NotificationInterface } from '../../../../../../interfaces/Notification';
import { StyledSeparator } from './Notification.styles';
import Deleting from './Deleting';
import Details from './Details';
import { removeNotification } from '../../../../../../actions/Notifications.actions';
import getNotificationsApiRoot from '../../../../../../utils/getNotificationsApiRoot';
import putReminder from '../../../../../../utils/putReminder';

export interface NotificationProps {
  notification: NotificationInterface;
  index: number;
}

const Notification: FC<NotificationProps> = ({ notification, index }) => {
  const dispatch = useDispatch();
  const handleDeleted = useCallback(() => {
    if (notification.source === 'notification') {
      axios.delete(
        `${getNotificationsApiRoot()}/${encodeURIComponent(notification.id)}`,
        {
          headers: { 'Content-Type': 'application/json' },
          data: { notificationId: notification.id },
        },
      ).catch(() => { /* we don't catch those errors */ });
    } else if (notification.source === 'promotion') {
      putReminder(notification.id)
        .catch(() => { /* we do not catch those errors */ });
    }
    dispatch(removeNotification(notification.id));
  }, [dispatch, notification]);

  return (
    <>
      {index !== 0 ? null : <StyledSeparator />}
      <Deleting notification={notification} onDeleted={handleDeleted} />
      <Details notification={notification} />
      <StyledSeparator />
    </>
  );
};
export default Notification;
